import { useEffect, useState } from "react";
import { Download } from "lucide-react";

export default function InstallApp() {
  const [ready, setReady] = useState(!!window.__installPrompt);
  useEffect(() => {
    const on = () => setReady(true);
    const off = () => setReady(false);
    window.addEventListener("installready", on);
    window.addEventListener("appinstalled", off);
    return () => { window.removeEventListener("installready", on); window.removeEventListener("appinstalled", off); };
  }, []);
  if (!ready) return null;
  const install = async () => {
    const p = window.__installPrompt;
    p.prompt();
    await p.userChoice;
    window.__installPrompt = null;
    setReady(false);
  };
  return (
    <button onClick={install} className="shrink-0 h-10 md:h-11 px-3 rounded-full bg-green-600 hover:bg-green-700 text-white font-semibold flex items-center gap-1.5 transition-colors" data-testid="install-app-button">
      <Download className="w-4 h-4" /> <span className="hidden sm:inline">App Install</span>
    </button>
  );
}
